import axiosInstance from "../axiosInstance";

const CONTROLLER = "agents";

const get_agent_clients_page = async (search, state, page) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetPage?search=${
			search || ""
		}&state=${state}&pageNumber=${page}`,
	);
	return response.data;
};

const get_agent_clients_header_info = async (search) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentClientsHeader?search=${search || ""}`,
	);
	return response.data;
};

const get_agent_route_page = async (
	search,
	clientId,
	poolFilter,
	state,
	page,
	pageSize,
) => {
	const response = await axiosInstance.get(`${CONTROLLER}/GetAgentRoutesPage`, {
		params: {
			search: search,
			clientId: clientId,
			poolFilter: poolFilter,
			state: state,
			page: page,
			pageSize: pageSize,
		},
	});
	return response.data;
};

const find_pos_candidates = async (id) => {
	const response = await axiosInstance.get(`${CONTROLLER}/FindPosCandidates`, {
		params: { agentRouteId: id },
	});
	return response.data;
};

const confirm_validation = async (payload) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/ConfirmValidation`,
		payload,
	);
	return response.data;
};

const update_agent_route_state = async (state) => {
	const response = await axiosInstance.put(
		`${CONTROLLER}/UpdateAgentRouteState`,
		state,
	);
	return response.data;
};

const add_agent_routes = async (payload) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/UpdateAgentRoutes`,
		payload,
	);
	return response.data;
};

const remove_agent_routes = async (payload) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/RemoveAgentRoutes`,
		payload,
	);
	return response.data;
};

const create_pos_from_route = async (payload) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/CreatePosFromAgentRoute`,
		payload,
	);
	return response.data;
};

const add_agent_route_by_cuit = async (data) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/AddAgentRouteByCuits`,
		data,
		{
			headers: {
				"Content-Type": "multipart/form-data",
			},
		},
	);
	return response.data;
};

const get_agent_pos_with_last_conv = async ({
	clientId,
	poolFilter,
	search,
	state,
	phase,
	routeTag,
	sortLastConversation,
	page,
	actualPage,
}) => {
	const { data } = await axiosInstance.get(
		`${CONTROLLER}/GetAgentRouteConversations`,
		{
			params: {
				clientId,
				poolFilter,
				search,
				state,
				phase,
				routeTag,
				sortLastConversation,
				page,
				actualPage,
			},
		},
	);
	return data;
};

const get_pos_conversations_page = async ({
	clientId,
	pointOfSaleId,
	page,
	actualPage,
}) => {
	const { data } = await axiosInstance.get(
		`${CONTROLLER}/GetAgentPosConversations`,
		{
			params: { clientId, pointOfSaleId, page, actualPage },
		},
	);
	return data;
};

const get_conversation_messages_page = async ({
	conversationId,
	page,
	actualPage,
}) => {
	const { data } = await axiosInstance.get(
		`${CONTROLLER}/GetAgentConversationMessages`,
		{
			params: { conversationId, page, actualPage },
		},
	);
	return data;
};

const take_over_conversation = async (conversationId, reason) => {
	const { data } = await axiosInstance.post(
		`${CONTROLLER}/TakeOverConversation/${conversationId}`,
		{ reason },
	);
	return data;
};

const release_conversation_to_agent = async (conversationId) => {
	const { data } = await axiosInstance.post(
		`${CONTROLLER}/ReleaseConversationToAgent/${conversationId}`,
	);
	return data;
};

const send_human_conversation_message = async (conversationId, text) => {
	const { data } = await axiosInstance.post(
		`${CONTROLLER}/SendHumanConversationMessage/${conversationId}`,
		{ text },
	);
	return data;
};

const agent_routes_to_validate = async (data) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/ValidateAgentRoutesByCuit`,
		data,
		{
			headers: {
				"Content-Type": "multipart/form-data",
			},
		},
	);
	return response.data;
};

const export_agent_routes_to_validate = async (clientId) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/ExportAgentRoutesToValidate?clientId=${clientId || ""}`,
		{
			responseType: "blob",
		},
	);
	return response.data;
};

const get_conversation_phases = async (clientId) => {
	const { data } = await axiosInstance.get(
		`${CONTROLLER}/GetConversationPhases?clientId=${clientId || ""}`,
	);
	return data;
};

const get_agent_config_by_id = async (clientId) => {
	const response = await axiosInstance.get(`${CONTROLLER}/GetAgentConfigById`, {
		params: {
			clientId: clientId,
		},
	});
	return response.data;
};

const create_agent_config = async (payload) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/CreateAgentConfig`,
		payload,
	);
	return response.data;
};

const update_agent_config = async (id, payload) => {
	const response = await axiosInstance.put(
		`${CONTROLLER}/UpdateAgentConfig/${id}`,
		payload,
	);
	return response.data;
};

const get_agent_configs_page = async (search, state, page) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetConfigPage?search=${
			search || ""
		}&state=${state}&pageNumber=${page}`,
	);
	return response.data;
};

const send_template_to_pos = async (payload) => {
	const res = await axiosInstance.post(
		`${CONTROLLER}/SendAgentTemplate`,
		payload,
	);
	return res.data;
};

const update_agent_orders = async (payload) => {
	const response = await axiosInstance.put(
		`${CONTROLLER}/UpdateAgentOrderState`,
		payload,
	);
	return response.data;
};

const get_agent_conversation_by_id = async (conversationId) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentConversationById`,
		{
			params: {
				conversationId: conversationId,
			},
		},
	);
	return response.data;
};

const get_agent_orders_page = async (search, state, page, size) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentOrderPage?search=${
			search || ""
		}&state=${state}&pageNumber=${page}&pageSize=${size}`,
	);
	return response.data;
};

const get_agent_orders_header_info = async (search) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentOrdersHeader?search=${search || ""}`,
	);
	return response.data;
};

const get_total_agent_order = async (laboratoryId) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetTotalPendingOrderCT?laboratoryId=${laboratoryId || ""}`,
	);
	return response.data;
};

const get_agents_panel_page = async (search, state, page) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentPanel?search=${
			search || ""
		}&state=${state}&pageNumber=${page}`,
	);
	return response.data;
};

const create_agent = async (payload) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/CreateAgent`,
		payload,
	);
	return response.data;
};

const get_agent_by_id = async (id) => {
	const response = await axiosInstance.get(`${CONTROLLER}/GetAgentById`, {
		params: {
			id: id,
		},
	});
	return response.data;
};

const update_agent = async (id, payload) => {
	const res = await axiosInstance.put(
		`${CONTROLLER}/UpdateAgent/${id}`,
		payload,
	);
	return res.data;
};

const get_agent_pos_selection_ids = async (params) => {
	const res = await axiosInstance.get(`${CONTROLLER}/GetSelectionIds`, {
		params,
	});
	return res.data;
};

const validate_whatsapps_list = async (clientId) => {
	const { data } = await axiosInstance.post(
		`${CONTROLLER}/ValidateWhatsappByClientId`,
		{ clientId },
	);
	return data;
};

const validate_whatsapp_single = async (userId, whatsappUserId, clientId) => {
	const { data } = await axiosInstance.post(
		`${CONTROLLER}/ValidateWhatsappByUserId`,
		{
			userId: userId || null,
			whatsappUserId: whatsappUserId || null,
			clientId: clientId || null,
		},
	);
	return data;
};

const get_client_templates = async (clientId) => {
	const { data } = await axiosInstance.get(
		`${CONTROLLER}/ClientTemplates?clientId=${clientId}`,
	);
	return data;
};

const sync_client_templates = async (clientId) => {
	const { data } = await axiosInstance.post(`${CONTROLLER}/SyncMetaTemplates`, {
		clientId,
	});
	return data;
};

const set_client_templates = async (payload) => {
	const { data } = await axiosInstance.post(
		`${CONTROLLER}/AssignTemplates`,
		payload,
	);
	return data;
};

const get_templates_catalog = async (params) => {
	const qs = new URLSearchParams(params).toString();
	const { data } = await axiosInstance.get(`${CONTROLLER}/GetCatalog?${qs}`);
	return data;
};

const get_agent_token_usage_summary = async (params) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentTokenSummary`,
		{ params },
	);
	return response.data;
};

const get_agent_token_usage_conversations = async (params) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentTokenConversations`,
		{ params },
	);
	return response.data;
};

const get_agent_token_usage_pointsOfSale = async (params) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentTokenPointsOfSale`,
		{ params },
	);
	return response.data;
};

const get_agent_token_usage_conversation_detail = async (params) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentTokenConversationDetail`,
		{ params },
	);
	return response.data;
};

const update_agent_route_tag = async (data) => {
	const res = await axiosInstance.put(
		`${CONTROLLER}/UpdateAgentRouteTag`,
		data,
	);
	return res.data;
};

const get_agent_client_route_tags = async (clientId) => {
	const res = await axiosInstance.get(
		`${CONTROLLER}/GetClientRouteTags?clientId=${clientId}`,
	);
	return res.data;
};

const get_whatsapp_products = async (whatsappId) => {
	const res = await axiosInstance.get(
		`${CONTROLLER}/GetAgentProductsById/${whatsappId}`,
	);
	return res.data;
};

const get_available_whatsapp_products = async ({
	whatsappId,
	search = "",
	skip = 0,
	take = 25,
}) => {
	const res = await axiosInstance.get(
		`${CONTROLLER}/GetAgentAvailableProducts?whatsAppId=${whatsappId}&search=${search}&skip=${skip}&take=${take}`,
	);
	return res.data;
};

const update_whatsapp_products = async (whatsappId, body) => {
	const res = await axiosInstance.put(
		`${CONTROLLER}/UpdateAgentProducts/${whatsappId}`,
		body,
	);
	return res.data;
};

const delete_whatsapp_product = async (whatsappId, productId) => {
	const res = await axiosInstance.delete(
		`${CONTROLLER}/DeleteAgentProduct/${whatsappId}/${productId}`,
	);
	return res.data;
};

const get_agents_by_client_id = async (search, clientId, state, page) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentsByClientId?search=${
			search || ""
		}&clientId=${clientId}&state=${state}&pageNumber=${page}`,
	);
	return response.data;
};

const export_whatsapp_products = async (body) => {
	const res = await axiosInstance.post(
		`${CONTROLLER}/ExportWhatsAppProducts`,
		body,
		{
			responseType: "blob",
		},
	);

	return res.data;
};

const import_whatsapp_products = async (formData) => {
	const res = await axiosInstance.post(
		`${CONTROLLER}/ImportWhatsAppProducts`,
		formData,
		{
			headers: {
				"Content-Type": "multipart/form-data",
			},
		},
	);

	return res.data;
};

const confirm_imported_whatsapp_products = async (body) => {
	const res = await axiosInstance.post(
		`${CONTROLLER}/ConfirmImportedWhatsAppProducts`,
		body,
	);

	return res.data;
};

const get_client_quotas = async (clientId) => {
	const { data } = await axiosInstance.get(
		`${CONTROLLER}/GetAgentsClientQuota?clientId=${clientId}`,
	);
	return data;
};

export {
	get_agent_clients_page,
	get_agent_route_page,
	get_agent_clients_header_info,
	find_pos_candidates,
	confirm_validation,
	update_agent_route_state,
	add_agent_routes,
	remove_agent_routes,
	create_pos_from_route,
	add_agent_route_by_cuit,
	agent_routes_to_validate,
	export_agent_routes_to_validate,
	get_agent_pos_with_last_conv,
	get_conversation_messages_page,
	take_over_conversation,
	release_conversation_to_agent,
	send_human_conversation_message,
	get_pos_conversations_page,
	get_conversation_phases,
	get_agent_config_by_id,
	create_agent_config,
	update_agent_config,
	get_agent_configs_page,
	send_template_to_pos,
	update_agent_orders,
	get_agent_conversation_by_id,
	get_agent_orders_page,
	get_agent_orders_header_info,
	get_total_agent_order,
	get_agents_panel_page,
	create_agent,
	get_agent_by_id,
	update_agent,
	get_agent_pos_selection_ids,
	validate_whatsapps_list,
	validate_whatsapp_single,
	get_client_templates,
	sync_client_templates,
	set_client_templates,
	get_templates_catalog,
	get_agent_token_usage_summary,
	get_agent_token_usage_conversation_detail,
	get_agent_token_usage_pointsOfSale,
	get_agent_token_usage_conversations,
	update_agent_route_tag,
	get_agent_client_route_tags,
	get_whatsapp_products,
	get_available_whatsapp_products,
	update_whatsapp_products,
	delete_whatsapp_product,
	get_agents_by_client_id,
	export_whatsapp_products,
	import_whatsapp_products,
	confirm_imported_whatsapp_products,
	get_client_quotas,
};
